import {createAction} from 'util/redux';
import {ThemeOptions} from '@mui/material';

export const globalThemeChangedAction = createAction<ThemeOptions | null>('GLOBAL_THEME_CHANGED');